import { useState, useEffect } from "react";
import ApiCalling from "../../ApiServices/ApiCalling";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const LoginWithOtpSevice = () => {
  const [inputOtp, setInputOtp] = useState({});
  const [validationOTPErrors, setValidationOTPErrors] = useState({});
  const [getOtpGenData, setOtpGenData] = useState({});
  const [isOtpGenerated, setIsOtpGenerated] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [location, setLocation] = useState({ latitude: 0, longitude: 0 });
  const navigate = useNavigate();

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (error) => {
          console.log("Location error:", error.message);
          toast.error("Location access denied. Using default location.");
        }
      );
    } else {
      toast.error("Geolocation is not supported by this browser.");
    }
  }, []);

  const handleChangeOTP = (e) => {
    const { name, value } = e.target;
    setInputOtp((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const validateFormOTP = (inputOtp, setValidationOTPErrors) => {
    const errors = {};

    if (!inputOtp?.UserID || inputOtp?.UserID.trim() === "") {
      errors.UserID = "UserId is required.";
    } else if (!/^[6-9]\d{9}$/.test(inputOtp.UserID)) {
      errors.UserID = "Enter a valid  mobile number.";
    }
    setValidationOTPErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const generateOtp = async (e) => {
    if (!validateFormOTP(inputOtp, setValidationOTPErrors)) {
      return;
    }
    e.preventDefault();
    try {
      const bodyObject = {
        LoginTypeID: 1,
        UserID: inputOtp?.UserID,
        Longitude: location?.longitude,
        Latitude: location?.latitude,
      };

      const res = await ApiCalling.request(
        "POST",
        "/LoginWithOTPAsync",
        bodyObject,
        null
      );
      if (res?.statuscode === 2) {
        setOtpGenData(res?.otpSession);
        setIsOtpGenerated(true);
        toast.success("OTP has been sent to your number");
      } else {
        toast.error(res?.msg, { toastId: "LoginWithOTPAsync error" });
        setTimeout(() => {
          navigate("/signup");
        }, 1000);
      }
    } catch (error) {
      console.error("Error LoginWithOTPAsync in:", error);
    }
  };

  const logInWithOtp = async (e) => {
    e.preventDefault();
    try {
      const bodyObject = {
        LoginTypeID: 1,
        OTP: otpValue,
        OTPSession: getOtpGenData,
      };
      const res = await ApiCalling.request(
        "POST",
        "/ValidateOTP",
        bodyObject,
        null
      );
      if (res?.statuscode === 1) {
        toast.success(res?.msg, { toastId: "login success", autoClose: 700 });
        sessionStorage.setItem("session", res?.data?.session);
        sessionStorage.setItem("sessionID", res?.data?.sessionID);
        sessionStorage.setItem("userID", res?.data?.userID);
        sessionStorage.setItem("name", res?.data?.name);
        sessionStorage.setItem("emailID", res?.data?.emailID);
        sessionStorage.setItem("roleName", res?.data?.roleName);
        sessionStorage.setItem("mobileNo", res?.data?.mobileNo);
        sessionStorage.setItem("justLoggedIn", "true");
        window.history.back(); //go back
      } else {
        toast.error(res?.msg, { toastId: "logInWithOtp error" });
      }
    } catch (error) {
      console.error("Error logInWithOtp in:", error);
    }
  };

  return {
    handleChangeOTP,
    inputOtp,
    generateOtp,
    validationOTPErrors,
    logInWithOtp,
    isOtpGenerated,
    otpValue,
    setOtpValue,
  };
};

export default LoginWithOtpSevice;
